export const logger = !import.meta.env.SITE
  ? (...message: any[]) => console.log(...message)
  : () => {
      /* noop */
    };
